import {
  GET_COUNTRIES_SUCCESS,
  DELETE_ACCOUNT_SUCCESS,
  GET_CITIES_SUCCESS,
  UPDATE_USER_AVATAR_SUCCESS,
} from './types';

const initialState = {
  countries: [],
  cities: [],
  userAvatarPath: '',
  isDeleteUserSuccess: false,
};

export const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload,
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        isDeleteUserSuccess: true,
      };
    case GET_CITIES_SUCCESS:
      return {
        ...state,
        cities: action.payload,
      };
    case UPDATE_USER_AVATAR_SUCCESS:
      return {
        ...state,
        userAvatarPath: action.payload,
      };
    default:
      return state;
  }
};
